import React, { useState } from "react";
import { Card } from "melodies-source/Card";
import styled from "styled-components";
import { Button } from "melodies-source/Button";
import { Body2, H3 } from "melodies-source/Text";
import { ModalSave } from "./ModalSave";
import { ModalDelete } from "./ModalDelete";

export interface Platform {
  id: "googleTracking" | "metaTracking" | "tiktokTracking";
  logo: React.ReactNode;
  name: string;
  description: string;
  extractId: (embed: string) => string | undefined;
  inputLabel: {
    id: string;
    code: string;
  };
  placeholder: {
    id: string;
    code: string;
  };
  setValue: (value: string, type?: "id" | "code" | "remove") => void;
  value: string;
}

interface Props {
  platform: Platform;
}

export const PlatformCard: React.FC<Props> = ({ platform }) => {
  const [modalSaveIsOpen, setModalSaveIsOpen] = useState(false);
  const [modalRemoveIsOpen, setModalRemoveIsOpen] = useState(false);
  const { logo, name, description } = platform;

  const toggleModalSaveOpen = () => setModalSaveIsOpen((open) => !open);
  const toggleModalRemoveOpen = () => {
    setModalRemoveIsOpen((open) => !open);
  };

  return (
    <>
      <StyledCard isElevated>
        {logo}
        <div>
          <H3>{name}</H3>
          <Body2>{description}</Body2>
        </div>
        <Actions>
          {platform.value && (
            <Button text onClick={toggleModalRemoveOpen}>
              Remove
            </Button>
          )}
          <Button
            variant={platform.value ? "primary" : "outlined"}
            onClick={toggleModalSaveOpen}
          >
            {platform.value ? "Edit" : "Add"}
          </Button>
        </Actions>
      </StyledCard>
      {modalSaveIsOpen && (
        <ModalSave
          platform={platform}
          isOpen={modalSaveIsOpen}
          onClose={toggleModalSaveOpen}
        />
      )}
      {modalRemoveIsOpen && (
        <ModalDelete
          platform={platform}
          isOpen={modalRemoveIsOpen}
          onClose={toggleModalRemoveOpen}
        />
      )}
    </>
  );
};

const StyledCard = styled(Card)`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 20px;
  align-items: center;
  box-shadow: 0px 0px 40px var(--box-shadow-color);

  ${({ theme }) => theme.media.mobile} {
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto;
  }
`;

const Actions = styled.div`
  display: flex;

  ${({ theme }) => theme.media.mobile} {
    grid-column: 1 / -1;
    flex-direction: column-reverse;
    margin-top: 10px;
  }
`;
